import { BannerConfigSchema, type BannerConfig } from '@hud/core';
import { registerWidget, type WidgetProps } from '../registry.js';
import { useAsset } from '../hooks/useAsset.js';
import './banner.css';

/**
 * A full-bleed image at the top of a dashboard.
 *
 * Almost no logic, and responsible for a large share of how the dashboard
 * feels — which is why it's in the first widget batch rather than the polish
 * pass. Set `bare: true` on the widget to drop the card chrome around it.
 */
function Banner({ config }: WidgetProps<BannerConfig>) {
  const isRemote = /^(https?:)?\/\//.test(config.src) || config.src.startsWith('data:');
  const src = useAsset(config.src, isRemote);

  return (
    <figure class="hud-banner">
      <img
        class="hud-banner__img"
        src={src}
        alt={config.alt}
        style={{ objectFit: config.fit, objectPosition: config.position }}
        loading="lazy"
        decoding="async"
      />
      {config.caption ? <figcaption class="hud-banner__caption">{config.caption}</figcaption> : null}
    </figure>
  );
}

registerWidget({
  type: 'banner',
  schema: BannerConfigSchema,
  component: Banner,
});
